import { addressError, AddressForm, ErrorType } from '../../../global-types/addresses';
import { AddAddressToValidate } from '../hooks/use-address-confirmation-dialog';

// handles the error validation for 1:M (return-recipient) cards
export const handleErrorValidation = (
  allErrors: ErrorType[],
  addAddressToValidate: AddAddressToValidate,
  addressForm: AddressForm,
  isRecipientAddress: boolean,
) => {
  // loop through all the errors and check if they are address errors
  allErrors.forEach((error: ErrorType) => {
    // if the error is an address error, set the address to validate
    if (addressError[String(error)]) {
      const addressId = addressForm.address_id || '';

      // add parsed address to validate
      addAddressToValidate(addressForm, error, isRecipientAddress ? 1 : 0, addressId);
    }
  });
};
